import { BorderRadius, Color, LottieAnimation } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface ProcessingOverlayProps {
  borderRadius?: BorderRadius
  color?: Color
  isSticky?: boolean
  label?: string
  withAnimation?: boolean
}

export const ProcessingOverlay = ({
  borderRadius,
  color,
  isSticky = false,
  label,
  withAnimation,
}: ProcessingOverlayProps): ReactElement => (
  <Styled.ProcessingOverlayWrapper
    aria-label={label}
    bgColor={color}
    borderRadius={borderRadius}
    isSticky={isSticky}
    role="status"
  >
    {withAnimation && (
      <Styled.AnimationWrapper isSticky={isSticky}>
        <LottieAnimation name="processing" width={60} height={60} />
      </Styled.AnimationWrapper>
    )}
  </Styled.ProcessingOverlayWrapper>
)
